var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown no-padding mr-4" }, [
    _c(
      "button",
      {
        staticClass: "btn no-bg dropdown-toggle text-white",
        staticStyle: { "font-size": "16px" },
        attrs: {
          id: "dropdownMenuButton",
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm.$store.state.app.lang == "en"
          ? _c("span", [_vm._v("English")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.app.lang == "zh"
          ? _c("span", [_vm._v("简体中文")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.app.lang == "id"
          ? _c("span", [_vm._v("Bahasa Indonesia")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.app.lang == "vi"
          ? _c("span", [_vm._v("Tiếng Việt")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.app.lang == "th"
          ? _c("span", [_vm._v("ภาษาไทย")])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu dropdown-menu-right",
        attrs: { "aria-labelledby": "dropdownMenuButton" }
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            on: {
              click: function($event) {
                return _vm.switchLang("en")
              }
            }
          },
          [_vm._v("\n      English\n    ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            on: {
              click: function($event) {
                return _vm.switchLang("zh")
              }
            }
          },
          [_vm._v("\n      简体中文\n    ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            on: {
              click: function($event) {
                return _vm.switchLang("id")
              }
            }
          },
          [_vm._v("\n      Bahasa Indonesia\n    ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            on: {
              click: function($event) {
                return _vm.switchLang("vi")
              }
            }
          },
          [_vm._v("\n      Tiếng Việt\n    ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            on: {
              click: function($event) {
                return _vm.switchLang("th")
              }
            }
          },
          [_vm._v("\n      ภาษาไทย\n    ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73b31b3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b31b3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/DropdownLang.vue
// module id = null
// module chunks = 